import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/header.png'


const _withScopeId = n => (_pushScopeId("data-v-0a8764bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full mx-auto h-screen bg-gradient-to-t from-bg-primary-dark to-bg-primary text-text-color overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "loading-div"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "helper" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "auth-container m-auto flex flex-col gap-y-2 items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header flex justify-center p-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo",
      src: _imports_0
    })
  ])
], -1))
const _hoisted_8 = { class: "auth-form w-full" }
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center text-2xl font-bold my-2 mb-5" }, "Login", -1))
const _hoisted_11 = {
  key: 0,
  class: "error text-red-500 text-center font-bold"
}
const _hoisted_12 = { class: "form-group my-2" }
const _hoisted_13 = { class: "form-group my-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group my-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "w-full bg-link-color text-white px-3 py-2 rounded-lg focus:outline-none",
    type: "submit"
  }, "Login")
], -1))
const _hoisted_15 = { class: "auth-links flex w-full justify-between" }

import { defineComponent } from 'vue';
import { auth } from "../firebase/config";
import FirebaseUtil from '../firebase/FirebaseUtil';
import { 
    signInWithEmailAndPassword,
} from "firebase/auth"
import { FirebaseError } from '@firebase/util';
import { ref } from "@vue/reactivity"
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const email = ref(null)
const password = ref(null)
const error = ref('')
const showEmailError = ref(false)
const showPasswordError = ref(false)
const firebaseUtilObj= new FirebaseUtil()
const showPassword = ref(false)
const isLoading = ref(false)

const triggerPassword = ()=>{

    showPassword.value = ! showPassword.value;

    if(showPassword)
    {
        document.getElementById("registerPassword")!.setAttribute("type","text")
    }
    else{
        document.getElementById("registerPassword")!.setAttribute("type","password")
    }
}

const validate = ()=> {

    error.value = "";
    console.log(email.value, password.value)
    //validate form fields
    if(! validateEmail())
    {
        error.value = "Invalid Field(s)";
        showEmailError.value = true;
        
    }

    if(! password.value ||  password.value.trim() == "")
    {
        error.value = "Invalid Field(s)";
        showPasswordError.value = true;                
    }

    console.log(error)
    if( error.value) return

    signin();
}

const validateEmail = () => {

    const reg= /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

    if ( email.value &&  email.value.trim() != "" && reg.test( email.value)) {
        return true;
    }

    return false;
}

const signin = async () => {

    try{
        isLoading.value = true
        const response = await signInWithEmailAndPassword(auth,email.value,password.value)

        if(response)
        {
            //get user object
            let user = response.user

            //signup successful, emit message
            console.log("Sign up complete - user", user);

            //store user                    
            router.push({ name: "Home"})
            
        }
        else{
            throw new Error('Failed to Sign in')
        }
    } 
    catch (err: any)
    {
        //error signing in
        if(err instanceof FirebaseError)
            error.value = firebaseUtilObj.handlerError(err)
        else
            error.value = err.message;

            isLoading.value = false
    }

}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(validate, ["prevent"])
        }, [
          _hoisted_10,
          (_unref(error))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(error)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["focus:outline-none rounded-md px-3 py-1 w-full", {'input-error':_unref(showEmailError)}]),
              name: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
              type: "email",
              placeholder: "Email",
              required: "",
              autocomplete: "false"
            }, null, 2), [
              [_vModelText, _unref(email)]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["focus:outline-none rounded-md px-3 py-1 w-full", {'input-error':_unref(showPasswordError)}]),
              name: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
              type: "password",
              placeholder: "Password",
              required: ""
            }, null, 2), [
              [_vModelText, _unref(password)]
            ])
          ]),
          _hoisted_14
        ], 40, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "underline text-sm",
          to: {name:'reset-password'}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Forgot your password?")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "underline text-sm",
          to: {name:'register'}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Click here to sign up")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})